import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// React-Youtube
import YouTube from 'react-youtube-embed'
import { Link } from "react-router-dom";
// core components

import thumbnailsStyle from "assets/jss/material-kit-react/views/homePageSections/thumbnails.jsx";
import ClipUtils from "../utils/ClipUtils";

class Thumbnail extends React.Component {

  computeUrl(){
    return ClipUtils.computeUrl(this.props.sentence, this.props.id);
  }

  render() {
    const { classes } = this.props;

    return (
      <Link to={this.computeUrl()} className={classes.dropdownLink}>
        <div className={classes.thumbnail}>
          <YouTube
              id={this.props.youtube_id}
              appendSrc={"?start="+this.props.start_time+"&end="+this.props.end_time}/>
          <br />

          {this.props.sentence}
          <br />
          {this.props.keywords !== undefined && this.props.keywords.map(keyword =>
              <span className={classes.keyword}>#{keyword} </span>
          )}
        </div>
      </Link>
    );
  }
}

export default withStyles(thumbnailsStyle)(Thumbnail);



// WEBPACK FOOTER //
// ./src/components/Thumbnail.jsx